import {
    CHECKIN,
    GET_CHECKIN,
    GET_ALL_CHECKINS,
    DELETE_CHECKIN
} from '../actions/types';

export default function (state = null, action) {
    switch (action.type) {
        case CHECKIN:
            return action.payload;
        case GET_ALL_CHECKINS:
            return action.payload;
        case DELETE_CHECKIN:
            return action.payload;
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/app/reducers/checkin.js